export const DisplayBasic = `
<div>
  <div className="d-inline p-2 bg-primary text-white mr-1">d-inline</div>
  <div className="d-inline p-2 bg-dark text-white">d-inline</div>
</div>
    `

export const DisplayBasicMore = `
<div>
  <span className="d-block p-2 bg-primary text-white">d-block</span>
  <span className="d-block p-2 bg-dark text-white">d-block</span>
</div>
    `

export const DisplayHidden = `
<div>
  <div className="d-lg-none">hide on screens wider than lg</div>
  <div className="d-none d-lg-block">hide on screens smaller than lg</div>
</div>
    `
